// Function to remove empty or malformed ul elements for accessibility
function removeEmptyLists(container) {
  if (!container) return;
  
  // Get all ul elements in the container
  var allUls = container.querySelectorAll('ul');
  
  allUls.forEach(function(ul) {
    var lis = ul.querySelectorAll('li');
    var hasValidContent = false;
    
    // Check if ul has at least one li element with actual content
    if (lis.length > 0) {
      lis.forEach(function(li) {
        // Check if li has meaningful text content (not just whitespace)
        var liText = li.textContent.trim();
        if (liText.length > 0) {
          hasValidContent = true;
        }
      });
    }
    
    // Remove ul if it has no li elements OR if all li elements are empty
    if (!hasValidContent) {
      // Double check: if ul itself has no text content, it's safe to remove
      var ulText = ul.textContent.trim();
      if (ulText === '' || lis.length === 0) {
        ul.remove();
      }
    }
  });
  
  // Special handling for show-more-text: check for incomplete HTML structures
  // This can happen when truncatewords cuts HTML mid-tag
  var showMoreText = container.querySelector('.show-more-text');
  if (showMoreText) {
    // Check for ul elements that might have been cut off
    var uls = showMoreText.querySelectorAll('ul');
    uls.forEach(function(ul) {
      var lis = ul.querySelectorAll('li');
      var hasAnyContent = false;
      
      // Check each li for actual content
      lis.forEach(function(li) {
        if (li.textContent.trim().length > 0) {
          hasAnyContent = true;
        }
      });
      
      // If no li has content, remove the ul
      if (!hasAnyContent) {
        ul.remove();
      }
    });
  }
}

function setDescription(){
  if (document.querySelector('.show-more-wrapper')){
    document.querySelectorAll('.show-more-wrapper').forEach(item=>{
      // Remove empty ul elements for accessibility - run multiple times to catch all cases
      removeEmptyLists(item);
      
      // Also specifically target show-more-text
      var showMoreText = item.querySelector('.show-more-text');
      if (showMoreText) {
        removeEmptyLists(showMoreText);
      }

      if (item.querySelector('.show-more-btn')){
        item.querySelector('.show-more-btn').addEventListener('click', function(){
          console.log(item.querySelector('.show-more-first'));
            item.querySelector('.show-more-first').classList.add('currently-hidden');
          item.querySelector('.show-more-last').classList.remove('currently-hidden');
          // Remove empty ul elements after showing full content
          removeEmptyLists(item.querySelector('.show-more-last'));
          console.log('click')
        });
      }
      if (item.querySelector('.show-less-btn')){
        item.querySelector('.show-less-btn').addEventListener('click', function(){
          item.querySelector('.show-more-first').classList.remove('currently-hidden');
          item.querySelector('.show-more-last').classList.add('currently-hidden');
        });
      }


    });
    console.log('set 2');
  }
  console.log('set');

}
// Run cleanup function immediately if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", function() {
    setDescription();
  });
} else {
  setDescription();
}

// Also run after delays to catch any dynamically loaded content
setTimeout(function(){
  setDescription();
}, 100);

setTimeout(function(){
  setDescription();
}, 500);

setTimeout(function(){
  setDescription();
}, 1000);

// Use MutationObserver to watch for DOM changes and remove empty lists
if (typeof MutationObserver !== 'undefined') {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is a show-more-wrapper or contains one
            if (node.classList && node.classList.contains('show-more-wrapper')) {
              removeEmptyLists(node);
            } else if (node.querySelector && node.querySelector('.show-more-wrapper')) {
              removeEmptyLists(node.querySelector('.show-more-wrapper'));
            }
            // Also check for any ul elements added
            if (node.tagName === 'UL' || (node.querySelector && node.querySelector('ul'))) {
              var container = node.closest('.show-more-wrapper') || node.closest('.show-more-text');
              if (container) {
                removeEmptyLists(container);
              }
            }
          }
        });
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
